import React from 'react';
import PropTypes from 'prop-types';
import { Button, Link } from '@paypalcorp/pp-react';
import ExtraInfo from './ExtraInfo';
import ImageButtons from './ImageButtons';
import DeveloperLink from './DeveloperLink';

const DetailsTextContent = props => {
  const {
    title,
    subtitle,
    direction,
    buttonText,
    buttonUrl,
    linkText,
    linkUrl,
    extraInfo,
    imageButtonValues,
    handleClickFPTI,
    developerLink,
    handleClick,
    addDevLink,
    toolName
  } = props;
  return (
    <div
      className={`details-option-text ${
        direction === 'rtl'
          ? 'details-option-text-right'
          : 'details-option-text-left'
      }`}
    >
      <h3 className="align-left" dangerouslySetInnerHTML={{ __html: title }} />
      <p
        onClick={e =>
          e.target.tagName === 'A' && e.target.getAttribute('data-fptilinkname')
            ? handleClickFPTI(e.target.getAttribute('data-fptilinkname'))
            : {}
        }
        className="align-left"
        dangerouslySetInnerHTML={{ __html: subtitle }}
        role="presentation"
      ></p>
      <ExtraInfo extraInfo={extraInfo} />
      {linkUrl && (
        <Link
          className={'align-left link-as-button'}
          as="button"
          onClick={() => handleClick(linkUrl)}
        >
          {linkText}
        </Link>
      )}
      {buttonText && (
        <Button secondary onClick={() => handleClick(buttonUrl)}>
          {buttonText}
        </Button>
      )}
      <div className="details-option-image-button-container">
        <ImageButtons
          imageButtons={imageButtonValues}
          handleClickFPTI={handleClickFPTI}
          toolName={toolName}
        />
      </div>

      <DeveloperLink
        developerLink={developerLink}
        addDevLink={addDevLink}
        handleClick={handleClick}
      />
    </div>
  );
};

DetailsTextContent.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  direction: PropTypes.string,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  extraInfo: PropTypes.array,
  imageButtonValues: PropTypes.array,
  developerLink: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  handleClick: PropTypes.func,
  addDevLink: PropTypes.func,
  toolName: PropTypes.string
};
export default DetailsTextContent;
